import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter, Link} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import PieChart from 'react-minimal-pie-chart';
import * as AdminActions from '../../store/actions/adminActions';
import Boundary from '../Boundary.js';
import EngagementTickets from './EngagementTickets';
import ReactTable from 'react-table';
import userImage from '../../assets/128x128.jpg';
import api from '../../utils/api';

class Engagement extends Component {
    componentDidMount(){
        this.init();
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId){
            this.init();
        }
    }

    init = () => {
        // console.log("Initting");
        this.props.getEngagementPage(this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
        let stats = ["completion", "hours", "expectedTime", "maxPoints", "studentCount", "repeatRatio"];
        stats.map(s => {
            return this.props.getEngagementStat(s, this.props.match.params.courseId, this.props.user.id);
        });

        // Each chart
        this.props.getEngagementChart('attentiveness', 1, this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
        this.props.getEngagementChart('quiz', 1, this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
        this.props.getEngagementChart('watchTime', 1, this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
        this.props.getEngagementChart('tests', 1, this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
        this.props.getEngagementChart('sessionDuration', 1, this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
        this.props.getEngagementChart('attendance', 1, this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);

        let courseIds = [];
        if(this.props.match.params.courseId){
            courseIds = [this.props.match.params.courseId];
        }else{
            courseIds = this.props.adminCourses.map(c => c.id);
        }

        this.props.getInstructors(courseIds, this.props.user.id);

        this.props.getLeaderboardCount(courseIds, 20, this.props.user.id);

        this.props.getLeaderboard(courseIds, 0, 20, this.props.user.id);

    }

    renderSelectField = (name) => {
        if(this.props.engagementChartsLength){
            if(this.props.engagementChartsLength[name]){
                return (
                    <select name={name} value={this.props.engagementChartsLength[name]} onChange={e => {
                        this.props.getEngagementChart(name, parseInt(e.target.value), this.props.match.params.courseId, this.props.user.user.id, this.props.user.id);
                    }} className="form-control" required="required">
                        <option value={1}>Yesterday</option>
                        <option value={2}>2 day</option>
                        <option value={7}>1 Week</option>
                        <option value={30}>1 Month</option>
                        <option value={365}>1 Year</option>
                    </select>
                )
            }else{
                return (
                    <span></span>
                )
            }
        }else{
            return (
                <span></span>
            )
        }
    }

    renderpName = (doc) => {
        let row = doc.original;

        if(row.profileId){
            let title = (row.pname) ? row.pname : '';
        
            return (
                <div className="user-and-question">
                    <div className="uq-avatar-wrap"><Link to={'/student-profile/' + row.profileId}>{this.renderImg(row)}</Link></div>
                    <div>
                        <h3><Link to={'/student-profile/' + row.profileId}>{title}</Link></h3>
                    </div>
                </div>
            )
        }else{
            let title = (row.pname) ? row.pname : '';
        
            return (
                <div className="user-and-question">
                    <div className="uq-avatar-wrap"><Link to={'#'}>{this.renderImg(row)}</Link></div>
                    <div>
                        <h3><Link to={'#'}>{title}</Link></h3>
                    </div>
                </div>
            )
        }
    }

    columns = [
        {Header: this.props.match.params.courseId ? "Pos" : "Global Pos", id: this.props.match.params.courseId ? "pos" : "globalPos", accessor: this.props.match.params.courseId ? "pos" : "globalPos", className: 'v-middle'},
        {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderpName(row)},
        {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
        {Header: 'Quiz', id: "quizPercent", accessor: 'quizPercent', className: 'v-middle'},
        {Header: 'Attentiveness', id: "attentivePercent", accessor: 'attentivePercent', className: 'v-middle'},
        {Header: 'Course Completion', id: "completionPercent", accessor: 'completionPercent', className: 'v-middle'},

        {Header: 'Total Merits', id: "points", accessor: 'points', className: 'v-middle'},
    ];

    renderImg = (row) => {
        if(row){
            let avatar = userImage;
            if(row.avatar){
                if(row.avatar.indexOf('http') > -1){
                    avatar = row.avatar;
                }else{
                    avatar = api.makeFileURL(row.avatar, this.props.user.id);
                }
            }
            return (
                <img
                    src={avatar}
                    alt={row.name}
                />
            )
        }else{
            return (
                <img
                    src={userImage}
                    alt={row.name}
                />
            )
        }
    };

    linkToStudents = (e) => {
        e.preventDefault();
        this.props.history.push(`/admin/${this.props.match.params.courseId}/students`);
    }
    
    render(){
        return (
            <div>
                <div className="row">
                    <div className="col-sm-3">
                        <div className="panel customPanel PanelGradientBg">
                            <div className="panel-heading border-bottom">
                                <h3 className="panel-title">Course Completion</h3>
                            </div>
                            {this.props.engagementStats ?
                            <div className="panel-body sp-top-bottom20" style={{height: 169}}>
                                <div className="sp-top-bottom20 text-white">
                                    <PieChart
                                        style={{width: 100, margin: '0 auto'}}
                                        data={[
                                            {value: 100, color: '#555'},
                                            {value: this.props.engagementStats.completion ? this.props.engagementStats.completion : 0, color: '#e33339'}
                                        ]}
                                        totalValue={100}
                                        startAngle={-90}
                                        lineWidth={20}
                                        rounded={true}
                                    />
                                    <p className="diagnostic-pie-chart-counter engagement-chart-title">{
                                        this.props.engagementStats.completion ? this.props.engagementStats.completion : 0
                                        }%</p>

                                </div>
                            </div>
                            : null}
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="panel customPanel">
                            <div className="panel-heading border-bottom">
                                <h3 className="panel-title">Course Hours</h3>
                            </div>
                            {this.props.engagementStats ?
                            <div className="panel-body text-white text-center sp-top-bottom60" style={{height: '169px'}}>
                                <h3 className="font-300">
                                    {this.props.engagementStats.hours ?
                                        moment.utc(moment.duration(this.props.engagementStats.hours * 1000).asMilliseconds()).format("HH:mm:ss")
                                    : 0}
                                </h3>
                            </div>
                            : null}
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="panel customPanel">
                            <div className="panel-heading border-bottom">
                                <h3 className="panel-title">Expected Time</h3>
                            </div>
                            {this.props.engagementStats ?
                            <div className="panel-body  text-white text-center sp-top-bottom60" style={{height: '169px'}}>
                                <h3 className="font-300">{this.props.engagement.expectedTime ? this.props.engagement.expectedTime : 0} Days</h3>
                            </div>
                            : null}
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="course-summary-panels">
                            <div className="panel customPanel sm-bottom10">
                                <div className="panel-body coursePanelBtn">
                                    <div className="flex flex-justify-content-space-between">
                                        <h3>Course Repeat Ratio</h3>
                                        <h2>{this.props.engagement.courseRepeat ? this.props.engagement.courseRepeat : 0}</h2>
                                    </div>
                                </div>                                    
                            </div>
                            <div className="panel customPanel sm-bottom10">
                                <div className="panel-body coursePanelBtn">
                                    <div className="flex flex-justify-content-space-between">
                                        <h3>Maximum Points</h3>
                                        <h2>{this.props.engagementStats.maxPoints ? this.props.engagementStats.maxPoints : 0}</h2>
                                    </div>                                
                                </div>                                    
                            </div>
                            <div className="panel customPanel" onClick={e => this.linkToStudents(e)}>
                                <div className="panel-body coursePanelBtn2">
                                    <div className="flex flex-justify-content-space-between">
                                        <h3>Total Students</h3>
                                        <h2>{this.props.engagementStats.studentCount ? this.props.engagementStats.studentCount : 0}</h2>
                                    </div>                                
                                </div>                                    
                            </div>
                        </div>
                    </div>
                </div>                          
                <div className="dd" id="nestable3">
                    <ol className="dd-list">
                         <li className="dd-item dd3-item" data-id="12">
                            <div className="dd-handle dd3-handle"></div>
                            <div className="dd3-content">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Boundary>
                                            <EngagementTickets />
                                        </Boundary>
                                    </div>

                                </div>
                            </div>
                        </li>


                        <li className="dd-item dd3-item" data-id="11">
                            <div className="dd-handle dd3-handle"></div>
                            <div className="dd3-content">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Attentiveness</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                <div className="sp-top30">
                                                    <Boundary>
                                                        <div id="AttentivenessGraph">
                                                            {this.props.engagementChartsLoading['attentiveness'] ?
                                                                'Loading'
                                                            :
                                                                this.props.engagementCharts['attentiveness'] ?
                                                                    <ReactHighcharts
                                                                        config={this.props.engagementCharts['attentiveness']}
                                                                        isPureConfig={true}
                                                                        neverReflow={true}
                                                                        ref="chart1"
                                                                    />
                                                                :
                                                                'Couldnt load chart'
                                                            }
                                                        </div>
                                                    </Boundary>
                                                    
                                                </div>
                                            </div>   
                                            <div className="panel-footer">
                                                <div className="w-200">
                                                    <div className="form-select-overlay ">
                                                        {this.renderSelectField('attentiveness')}
                                                    </div>
                                                </div>
                                            </div>                                 
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Average Session Duration</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                <div className="sp-top30">
                                                    <Boundary>
                                                        <div id="asd">
                                                            {this.props.engagementChartsLoading['sessionDuration'] ?
                                                                'Loading'
                                                            :
                                                                this.props.engagementCharts['sessionDuration'] ?
                                                                    <ReactHighcharts
                                                                        config={this.props.engagementCharts['sessionDuration']}
                                                                        isPureConfig={true}
                                                                        neverReflow={true}
                                                                        ref="chart7"
                                                                    />
                                                                :
                                                                'Couldnt load chart'
                                                            }
                                                        </div>
                                                    </Boundary>
                                                </div>

                                            </div> 
                                            <div className="panel-footer">
                                                <div className="w-200">
                                                    <div className="form-select-overlay ">
                                                        {this.renderSelectField('sessionDuration')}
                                                    </div>
                                                </div>
                                            </div>                                   
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </li>


                        <li className="dd-item dd3-item" data-id="10">
                            <div className="dd-handle dd3-handle"></div>
                            <div className="dd3-content">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Quiz Scores</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                <div className="sp-top30">
                                                    <Boundary>
                                                        <div id="qsg">
                                                            {this.props.engagementChartsLoading['quiz'] ?
                                                                'Loading'
                                                            :
                                                                this.props.engagementCharts['quiz'] ?
                                                                    <ReactHighcharts
                                                                        config={this.props.engagementCharts['quiz']}
                                                                        isPureConfig={true}
                                                                        neverReflow={true}
                                                                        ref="chart2"
                                                                    />
                                                                :
                                                                'Couldnt load chart'
                                                            }
                                                        </div>
                                                    </Boundary>
                                                </div>
                                            </div>    
                                            <div className="panel-footer">
                                                <div className="w-200">
                                                    <div className="form-select-overlay ">
                                                        {this.renderSelectField('quiz')}
                                                    </div>
                                                </div>
                                            </div>                                
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Subject Test</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                <div className="sp-top30">
                                                    <Boundary>
                                                        <div id="tsg">
                                                            {this.props.engagementChartsLoading['tests'] ?
                                                                'Loading'
                                                            :
                                                                this.props.engagementCharts['tests'] ?
                                                                    <ReactHighcharts
                                                                        config={this.props.engagementCharts['tests']}
                                                                        isPureConfig={true}
                                                                        neverReflow={true}
                                                                        ref="chart3"
                                                                    />
                                                                :
                                                                'Couldnt load chart'
                                                            }
                                                        </div>
                                                    </Boundary>
                                                </div>
                                            </div>   
                                            <div className="panel-footer">
                                                <div className="w-200">
                                                    <div className="form-select-overlay ">
                                                        {this.renderSelectField('tests')}
                                                    </div>
                                                </div>
                                            </div>                                 
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>
                        </li>


                        <li className="dd-item dd3-item" data-id="9">
                            <div className="dd-handle dd3-handle"></div>
                            <div className="dd3-content">
                                <div className="row">
                                    
                                    <div className="col-sm-6">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Attendance</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                <div className="sp-top30">
                                                    <Boundary>
                                                        <div id="atsg">
                                                            {this.props.engagementChartsLoading['attendance'] ?
                                                                'Loading'
                                                            :
                                                                this.props.engagementCharts['attendance'] ?
                                                                    <ReactHighcharts
                                                                        config={this.props.engagementCharts['attendance']}
                                                                        isPureConfig={true}
                                                                        neverReflow={true}
                                                                        ref="char7"
                                                                    />
                                                                :
                                                                'Couldnt load chart'
                                                            }
                                                        </div>
                                                    </Boundary>
                                                </div>
                                            </div>   
                                            <div className="panel-footer">
                                                <div className="w-200">
                                                    <div className="form-select-overlay ">
                                                        {this.renderSelectField('attendance')}
                                                    </div>
                                                </div>
                                            </div>                                 
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Watch Time</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                <div className="sp-top30">
                                                    <Boundary>
                                                        <div id="wtg">
                                                            {this.props.engagementChartsLoading['watchTime'] ?
                                                                'Loading'
                                                            :
                                                                this.props.engagementCharts['watchTime'] ?
                                                                    <ReactHighcharts
                                                                        config={this.props.engagementCharts['watchTime']}
                                                                        isPureConfig={true}
                                                                        neverReflow={true}
                                                                        ref="chart4"
                                                                    />
                                                                :
                                                                'Couldnt load chart'
                                                            }
                                                        </div>
                                                    </Boundary>
                                                </div>
                                            </div>  
                                            <div className="panel-footer">
                                                <div className="w-200">
                                                    <div className="form-select-overlay ">
                                                        {this.renderSelectField('watchTime')}
                                                    </div>
                                                </div>
                                            </div>                                  
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </li>


                        <li className="dd-item dd3-item" data-id="8">
                            <div className="dd-handle dd3-handle"></div>
                            <div className="dd3-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <div className="panel customPanel">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Leadership Board</h3>
                                            </div>
                                            <div className="panel-body no-padding">
                                                 <div className="table-responsive">
                                                     <Boundary>
                                                     <ReactTable
                                                        data={this.props.leaderboard || []}
                                                        columns={this.columns}
                                                        resolveData={data => data.map(row => row)}
                                                        loading={this.props.leaderboardLoading || false}
                                                        pages={this.props.leaderboardCount || 0}
                                                        className="table-striped"
                                                        manual // informs React Table that you'll be handling sorting and pagination server-side
                                                        onFetchData={(state, instance) => {
                                                            // show the loading overlay
                                                            let courseIds = [];
                                                            if (this.props.match.params.courseId) {
                                                                courseIds.push(this.props.match.params.courseId);
                                                            } else {
                                                                courseIds = this.props.adminCourses.map(c => c.id);
                                                            }

                                                            // console.log("SORT/FILTER", state.sorted, state.filtered);
                                                            this.setState({loading: true})
                                                            // fetch your data
                                                            // console.log("PS", state.pageSize);
                                                            if(!isNaN(state.pageSize)){
                                                                this.props.getLeaderboardCount(courseIds, !isNaN(state.pageSize) ? state.pageSize : 20, this.props.user.id);

                                                            }
                                                            if(state.sorted.length > 0){
                                                                this.props.getSortedLeaderboard(courseIds, state.page * state.pageSize, state.sorted[0], state.pageSize, this.props.user.id);
                                                            }else {
                                                                this.props.getLeaderboard(courseIds, state.page * state.pageSize, state.pageSize, this.props.user.id);

                                                            }
                                                        }}
                                                    />
                                                     </Boundary>
                                                 </div>
                                                    
                                            </div>                                    
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="panel customPanel ">
                                            <div className="panel-heading border-bottom">
                                                <h3 className="panel-title">Instructors</h3>
                                            </div>
                                            <div className="panel-body no-padding" style={{maxHeight: '560px', overflowY: 'auto'}}>
                                                <div className="user_image_list">
                                                   <ul>
                                                       <Boundary>
                                                           {this.props.courseInstructors.map(ci => {
                                                               return (
                                                                <li>
                                                                    {this.renderImg(ci)}
                                                                    <h3 class="font-300"><a href="#">{ci.pname.indexOf('undefined') > -1 ? ci.email : ci.pname}</a> </h3>
                                                                </li>
                                                               )
                                                           })}
                                                       </Boundary>
                                                   </ul>
                                                </div>
                                            </div>   
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </li>




                        
                    </ol>         
                </div>
                
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getEngagementPage: (courseId, userId, token) => {
        dispatch(AdminActions.getEngagementPage(courseId, userId, token));
    },
    getInstructors: (courseId, token) => {
        dispatch(AdminActions.getConsoleInstructors(courseId, token));
    },
    getEngagementChart: (view, length, courseId, userId, token) => {
        dispatch(AdminActions.getEngagementChart(view, length, courseId, userId, token));
    },
    getLeaderboard: (courseIds, token) => {
        dispatch(AdminActions.getLeaderboard(courseIds, token));
    },
    getLeaderboard: (courseIds, skip, limit, token) => {
        dispatch(AdminActions.getLeaderboard(courseIds, skip, limit, token));
    },
    getLeaderboardCount: (courseIds, pageSize, token) => {
        dispatch(AdminActions.getLeaderboardCount(courseIds, pageSize, token));
    },
    getSortedLeaderboard: (courseIds, skip, sort, pageSize, token) => {
        dispatch(AdminActions.getSortedLeaderboard(courseIds, skip, sort, pageSize, token));
    },
    getEngagementStat: (name, courseId, token) => {
        dispatch(AdminActions.getEngagementStat(name, courseId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Engagement));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Engagement.js